// src/state/urlState.ts
import { StepId, Steps } from "@/domains/quiz/StepDefinitions";

export type QuizMode = "quiz" | "results";

function mapNumericStepToStepId(n: number): StepId | undefined {
  const idx = n - 1;
  return Steps[idx]?.id;
}

function mapStepIdToNumeric(stepId: StepId): number {
  const idx = Steps.findIndex((s) => s.id === stepId);
  return idx >= 0 ? idx + 1 : 1;
}

export function readURLState(): {
  mode?: QuizMode;
  quizStep?: StepId;
  resultsStep?: number;
  dogId?: string;
} {
  if (typeof window === "undefined") return {};

  const params = new URLSearchParams(window.location.search);

  const modeParam = params.get("mode") as QuizMode | null;
  const mode: QuizMode | undefined =
    modeParam === "quiz" || modeParam === "results" ? modeParam : undefined;

  const stepParam = params.get("step");
  const resultsParam = params.get("results");
  const dogId = params.get("dog") || undefined;

  let quizStep: StepId | undefined;
  if (stepParam) {
    if (/^\d+$/.test(stepParam)) {
      const numeric = Number(stepParam);
      quizStep = mapNumericStepToStepId(numeric);
    } else {
      quizStep = stepParam as StepId;
    }
  }

  const resultsStep =
    resultsParam != null && !Number.isNaN(Number(resultsParam))
      ? Number(resultsParam)
      : undefined;

  return {
    mode,
    quizStep,
    resultsStep,
    dogId,
  };
}

export function writeQuizStepToURL(stepId: StepId, dogId?: string) {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);

  params.set("mode", "quiz");
  params.delete("results");

  const numeric = mapStepIdToNumeric(stepId);
  params.set("step", String(numeric));

  if (dogId) {
    params.set("dog", dogId);
  } else {
    params.delete("dog");
  }

  const newURL = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, "", newURL);
}

export function writeResultsStepToURL(step: number) {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);

  params.set("mode", "results");
  params.set("results", String(step));
  params.delete("step");

  const newURL = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, "", newURL);
}
